import HTForm from '../_shared/form/htform';
import { formInvalidMessage } from '../_shared/validation/validationhelpers';

export default class EmailReportForm extends HTForm {
    setup() {
        return {
            fields: [
                {
                    name: 'Name',
                    type: 'textfield',
                    value: '',
                    label: 'Name of person generating report',
                    rules: 'required',
                    extra: {
                        type: 'text',
                        maxLength: 255
                    }
                },
                {
                    name: 'LandlordName',
                    type: 'textfield',
                    value: '',
                    label: 'Landlord\'s name',
                    rules: 'required',
                    extra: {
                        type: 'text',
                        maxLength: 255
                    }
                },
                {
                    name: 'Address',
                    type: 'textareafield',
                    value: '',
                    label: 'Address of property',
                    rules: 'required',
                    extra: {
                        rows: 6
                    }
                },
                {
                    name: 'Email',
                    type: 'textfield',
                    value: '',
                    label: 'Email address',
                    rules: 'required|email',
                    extra: {
                        type: 'email',
                        maxLength: 255
                    }
                },
                {
                    name: 'EmailVerify',
                    type: 'textfield',
                    value: '',
                    label: 'Verify email address',
                    rules: 'required|email|same:Email',
                    extra: {
                        type: 'email',
                        maxLength: 255
                    }
                },
                {
                    name: 'Role',
                    type: 'radio',
                    value: '',
                    label: 'What is your role?',
                    rules: 'required',
                    extra: {
                        options: () => {
                            return [
                                {
                                    value: 'Heating Professional',
                                    label: 'Heating Professional'
                                },
                                {
                                    value: 'Landlord',
                                    label: 'Landlord'
                                },
                                {
                                    value: 'Property manager',
                                    label: 'Property manager'
                                },
                                {
                                    value: 'Tenant',
                                    label: 'Tenant'
                                }
                            ];
                        }
                    }
                }
            ]
        };
    };

    hooks() {
        return {
            onSuccess(form) {
                const values = form.values();
                this.store.emailReport(values, form);
            },
            onError(form) {
                form.invalidate(formInvalidMessage);
            }
        };
    };
}
